// src/components/OfferTests/OfferForYouDetails.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useCart } from "../../../context/CartContext";
import { useLabCart } from "../../../context/LabCartContext";
import { FaShoppingCart, FaStar } from "react-icons/fa";
import Simmer from "../../Loder/Simmer";

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
const IMAGE_BASE = API_BASE.replace("/api", "") + "/TestMasterImage/";

export default function OfferForYouDetails() {
  const { labId } = useParams();
  const { cart } = useCart();
  const { handleAddItem, handleRemoveItem } = useLabCart();

  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ratingsMap, setRatingsMap] = useState({});

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const res = await axios.post(`${API_BASE}/Lab/TestSearch`, {
          name: "",
          labId: Number(labId),
          symptomId: 0,
          pageNumber: 1,
          pageSize: 20
        });

        console.log("FULL API RESPONSE:", res.data);

        const results = res.data?.data?.tests || res.data?.data || res.data || [];
        setTests(results);

        const ratingsObj = {};
        results.forEach((t) => {
          const r = t.rating || t.Rating || t.avgRating || 0;
          ratingsObj[t.testID] = Number(r);
        });
        setRatingsMap(ratingsObj);

      } catch (err) {
        console.error("OfferForYouDetails API Error:", err);
        setTests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, [labId]);

  const isInCart = (testID) =>
    cart.some((i) => i.productId === testID && i.categoryId === 2);

  const buildCartItem = (test) => {
    const originalPrice =
      Number(test.testPrice) ||
      Number(test.mrp) ||
      Number(test.price) ||
      0;

    const price =
      Number(test.sellingPrice) ||
      Number(test.SellingPrice) ||
      Number(test.offerPrice) ||
      originalPrice;

    const discount = originalPrice - price;

    return {
      productId: test.testID,
      categoryId: 2,
      name: test.testName,
      price,
      discount,
      quantity: 1,
      storeId: test.labId || 0,
      originalPrice
    };
  };

  const handleAdd = (test) =>
    handleAddItem(buildCartItem(test), test.labId);

  const handleRemove = (test) =>
    handleRemoveItem(buildCartItem(test));

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalf = rating - fullStars >= 0.5;

    return [...Array(5)].map((_, i) => {
      if (i < fullStars)
        return <FaStar key={i} size={12} color="#ffc107" />;
      if (i === fullStars && hasHalf)
        return (
          <FaStar
            key={i}
            size={12}
            color="#ffc107"
            style={{ opacity: 0.5 }}
          />
        );
      return <FaStar key={i} size={12} color="#ddd" />;
    });
  };

  if (loading)
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 p-4">
        {[...Array(6)].map((_, i) => (
          <Simmer key={i} height="220px" />
        ))}
      </div>
    );

  if (!tests.length)
    return <p className="text-center mt-4">No tests found</p>;

  return (
        <div className="px-4 md:px-8 py-6 bg-gray-50 rounded-xl shadow-lg mt-5">
      <h4 className="text-center text-2xl md:text-3xl font-extrabold mb-6
        bg-gradient-to-r from-red-500 via-pink-500 to-orange-400
        bg-clip-text text-transparent tracking-wide">
        Offer Tests
      </h4>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {tests.map((test) => {
          const inCart = isInCart(test.testID);
          const rating = ratingsMap[test.testID] || 0;

          // ✅ SAFE PRICE LOGIC
          const sellingPrice =
            Number(test.sellingPrice) ||
            Number(test.SellingPrice) ||
            Number(test.offerPrice) ||
            Number(test.price) ||
            0;

          const originalPrice =
            Number(test.testPrice) ||
            Number(test.mrp) ||
            sellingPrice;

          const discount = originalPrice - sellingPrice;

          return (
            <div
              key={test.testID}
              className="flex flex-col justify-between border rounded-lg shadow-sm p-2 hover:shadow-md transition h-[220px]"
            >
              {/* Image */}
              <div className="flex justify-center items-center h-20 mb-1">
                <img
                  src={
                    test.testImage
                      ? `${IMAGE_BASE}${test.testImage}`
                      : "https://placehold.co/80"
                  }
                  alt={test.testName}
                  className="h-full object-contain"
                />
              </div>

              {/* Name */}
              <p className="text-sm font-semibold text-center line-clamp-2">
                {test.testName}
              </p>

              {/* Rating */}
              <div className="flex justify-center items-center gap-1 text-[10px] mt-1">
                {renderStars(rating)}
                <span>{rating ? rating.toFixed(1) : ""}</span>
              </div>

              {/* Price */}
              <div className="mt-auto flex justify-between items-center pt-2">
                <div className="text-sm font-semibold text-red-600">
                  ₹{sellingPrice}

                  {originalPrice > sellingPrice && (
                    <span className="line-through text-gray-400 ml-1 text-xs">
                      ₹{originalPrice}
                    </span>
                  )}

                  {discount > 0 && (
                    <span className="text-green-600 text-xs ml-1">
                      ({Math.round((discount / originalPrice) * 100)}% OFF)
                    </span>
                  )}
                </div>

                <button
                  onClick={() =>
                    inCart ? handleRemove(test) : handleAdd(test)
                  }
                  className={`flex items-center gap-1 px-2 py-[4px] rounded-md text-[11px] font-medium
                    ${
                      inCart
                        ? "bg-red-100 text-red-700 border border-red-700"
                        : "bg-green-100 text-green-700 border border-green-700"
                    }`}
                >
                  <FaShoppingCart size={12} />
                  {inCart ? "Remove" : "Add"}
                </button>
              </div>

              {/* Lab */}
              <p className="text-xs text-gray-500 text-center mt-1">
                {test.lab?.lab_name}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}